// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gW03B","overlay":"styles_overlay__NqS0m","close":"styles_close__+kzsG","content":"styles_content__E9TLR"};